<template>
    <div>
        <el-button type="primary" class="onlyBtn" plain icon="el-icon-search" @click="getBatchOptListHandler($event)">查询</el-button>
        <el-button type="success" icon="el-icon-edit" class="onlyBtn" plain  @click="showBatchChgStateHandler()">批量变更状态</el-button>
        <el-button type="success" icon="el-icon-edit" class="onlyBtn" plain  @click="showBatchChgStateHandler2()">批量变更通道</el-button>
        <el-button type="danger" plain icon="el-icon-delete" class="onlyBtn" @click="showBatchChgStateHandler1()">批量删除</el-button>
        <el-button type="danger" plain icon="el-icon-delete" class="onlyBtn" @click="showBatchChgStateHandler3()">批量删除实名缓存</el-button>
        <el-button type="success" plainicon="el-icon-edit" class="onlyBtn" @click="showBatchChgStateHandler4()">批量修改虚拟号</el-button>
        <el-button type="success" plainicon="el-icon-edit" class="onlyBtn" @click="showBatchChgStateHandler5()">批量修改代理账号</el-button>
        <el-table :data="tbpg.tableData" 
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 >
            <el-table-column prop="totalAmount" label="导入总数" align="center"></el-table-column>
            <el-table-column prop="successAmount" label="成功" align="center"></el-table-column>
            <el-table-column prop="failAmount" label="失败" align="center"></el-table-column>
            <el-table-column prop="typeNickname" label="导入类型" align="center"></el-table-column>
            <el-table-column prop="disposeNickename" label="操作人" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.failAmount > 0" type="text" @click="getOptFailListHandler(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true"  title="批量变更状态" :visible.sync="batchOptVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('import/sim/state/excel')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                
                <el-form-item label="导入类型：" prop="state">
                    <el-select v-model="batchOptForm.state" clearable>
                        <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="'转'+item.description"></el-option>
                    </el-select>


                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="batchOptForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div> 
        </el-dialog>      
         <el-dialog :append-to-body="true"  title="批量删除" :visible.sync="batchOptVisible1" width="600px" @close="cancel" :close-on-click-modal="false">
             <p style="color:red">批量删除后 数据无法进行恢复！请谨慎操作</p>
            <el-form ref="batchOptForm1" :model="batchOptForm1" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/delete/sims')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>            
        <el-dialog :append-to-body="true"  title="操作失败列表" :visible.sync="optFailVisible" width="1000px" :close-on-click-modal="false">
            <el-button type="primary" @click="confirmExportDialogVisible = true" style="margin-bottom:10px;"> 导 出</el-button>
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="pkgName" label="套餐名称"></el-table-column>
                <el-table-column prop="resorceName" label="卡来源"></el-table-column>
                <el-table-column prop="oldLoseTime" label="原本过期时间"></el-table-column>
                <el-table-column prop="newLoseTime" label="导入过期时间"></el-table-column>
                <el-table-column prop="typeNickname" label="导入类型"></el-table-column>
                <el-table-column prop="disposeNickename" label="操作人"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>  
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportSimFailHandler">确 定</el-button>
            </span>
        </el-dialog>








         <el-dialog :append-to-body="true"  title="批量变更通道" :visible.sync="batchOptVisible2" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('import/sim/state/update/supplier')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                
                <el-form-item label="新通道：" prop="supplierCode">
                    <el-select v-model="batchOptForm.supplierCode" clearable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="'转'+item.name"></el-option>
                    </el-select>
                </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler2">确 定</el-button>
            </div> 
        </el-dialog>      



        <el-dialog :append-to-body="true"  title="批量删除卡板缓存" :visible.sync="batchOptVisible3" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm1" :model="batchOptForm1" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/deleteSysAuth/batch')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=changeState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>        


        <el-dialog :append-to-body="true"  title="批量修改虚拟号" :visible.sync="batchOptVisible4" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm1" :model="batchOptForm1"  label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/updateVri/batch')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=updateVri')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>        

        <el-dialog :append-to-body="true"  title="批量修改账号状态" :visible.sync="batchOptVisible5" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm1" :model="batchOptForm1"  label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/agentState/batch')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=agentState')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>        

    </div>
</template>
<script>
import {getBatchOptList, getBatchOptFailList, batchChgState, exportSimChangeStateFail} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            branchSupplierOption: [],
            batchOptForm: {
                supplierCode:'',
                state: '',
                remark:'',
            },
             batchOptForm1: {
                supplierCode:'',
                state: '',
                remark:'',
            },
            batchOptVisible: false,
            batchOptVisible1: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            optFailVisible: false,
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
            confirmExportDialogVisible:false,

            changeStateRules: {
                state: [{required: true, message: '请选择变更状态', trigger: 'blur'}],
                remark: [{required: true, message: '请选择输入变更原因', trigger: 'blur'}],
            },

            cardStateOption:[],
            batchOptVisible2:false,
            batchOptVisible3:false,
            batchOptVisible4:false,
            batchOptVisible5:false,
            
        }
    },
    methods: {  
        showBatchChgStateHandler2(){
            this.batchOptVisible2=true;
        },
        showBatchChgStateHandler3(){
            this.batchOptVisible3=true;
        },
        showBatchChgStateHandler4(){
            this.batchOptVisible4=true;
        },
        showBatchChgStateHandler5(){
            this.batchOptVisible5=true;
        },
        cancel(){
            this.batchOptVisible = false;
            this.batchOptVisible1 = false;
            this.batchOptVisible2 = false;
            this.batchOptVisible3 = false;
            this.batchOptVisible4 = false;
            this.batchOptVisible5 = false;
            this.$refs.batchOptForm.resetFields();
        },
        getBatchOptListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', {});
            getBatchOptList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getOptFailListHandler(id, $event){
            this.optFailVisible = true;
            this.currentId_fail = id;
            var searchData = {id}
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchData);
            getBatchOptFailList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getBatchOptListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler(){
            this.batchOptVisible = true;
        },
         showBatchChgStateHandler1(){
            this.batchOptVisible1 = true;
        },
        sureBatchChgStateHandler(){ 
            this.$refs.batchOptForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
         sureBatchChgStateHandler2(){ 
            this.$refs.batchOptForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
            sureBatchChgStateHandler1(){ 
            this.$refs.batchOptForm1.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        exportSimFailHandler(){
            let data = {"updatasId": this.currentId_fail}
            exportSimChangeStateFail(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
                this.optFailVisible = false;
            })
        },
        handleSizeChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getBatchOptListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getBatchOptListHandler();
            }
        }        
    },
    created () {
        this.getBatchOptListHandler();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')

        common.sysRequest('sim/state/dict', {}, 'get').then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }   
        })
    }
}
</script>
<style>

</style>
